// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"juO5Q","recordsColumn":"sfbFC","vs_score":"p0IAo","score":"KAzn7","records":"sAoIQ"};